<template>
  <div class="consulting-operation">
    <div class="operation-container">
      <el-button type="primary" size="large" :loading="loading" @click="handleUpdateAllPrices" class="update-button">
        更新所有人价格
      </el-button>
    </div>
  </div>
</template>

<script>
import {updateAllUserPrices} from '../../api/background'

export default {
  name: 'ConsultingOperation',
  data() {
    return {
      loading: false
    }
  },
  methods: {
    // 更新所有人价格
    handleUpdateAllPrices() {
      this.$confirm('确认要更新所有人的价格吗？此操作将影响所有用户的价格设定。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          updateAllUserPrices({})
            .then(() => {
              this.$message.success('更新成功')
            })
            .catch(err => {
              console.error('更新所有人价格失败:', err)
              this.$message.error('更新失败，请稍后重试')
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(() => {
          // 用户取消
        })
    }
  }
}
</script>

<style scoped>
.consulting-operation {
  padding: 40px;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.operation-container {
  text-align: center;
}

.update-button {
  padding: 15px 40px;
  font-size: 16px;
  border-radius: 8px;
  background: linear-gradient(135deg, #20b2aa, #17a2b8);
  border: none;
  box-shadow: 0 4px 12px rgba(32, 178, 170, 0.3);
  transition: all 0.3s ease;
}

.update-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(32, 178, 170, 0.4);
}

.update-button:active {
  transform: translateY(0);
}

.update-button.is-loading {
  opacity: 0.8;
  cursor: not-allowed;
}
</style>
